import { render, staticRenderFns } from "./list-product-item-vacation.vue?vue&type=template&id=dbb057d6&"
import script from "./list-product-item-vacation.vue?vue&type=script&lang=js&"
export * from "./list-product-item-vacation.vue?vue&type=script&lang=js&"
import style0 from "./list-product-item-vacation.vue?vue&type=style&index=0&id=dbb057d6&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports